import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import "./assets/fonts/Inter/static/Inter-Regular.ttf";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store/store";
import "./index.scss";
import "./assets/fonts/Inter/static/Inter-Regular.ttf";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  // COMMENTED STRICT MODE AS APIs CALLED TWICE
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <ToastContainer />
      <App />
    </BrowserRouter>
  </Provider>,
  // </React.StrictMode>
);

reportWebVitals();
